"use strict";

exports.__esModule = true;
exports.TileContext = exports.FlatText = exports.FlatRow = exports.FlatDot = exports.FLAT_FONT_MONO = exports.FLAT_FONT_HEADING = exports.DeviceCardContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Tells a value tile (KPI value, timeline value, device property) how to draw
 * itself. A `flat` tile draws no card of its own: it is one line inside a card
 * that something else draws, and `role` says which line it is:
 * "title", "subtitle", "state" or "stat".
 */
var TileContext = exports.TileContext = /*#__PURE__*/_react["default"].createContext({
  flat: false,
  role: undefined
});

/**
 * True while rendering the repeated template of a DeviceGrid item, where the
 * template Grid becomes a designed device card rather than a positioned grid.
 */
var DeviceCardContext = exports.DeviceCardContext = /*#__PURE__*/_react["default"].createContext(false);
var FLAT_FONT_HEADING = exports.FLAT_FONT_HEADING = 'Archivo, "IBM Plex Sans", -apple-system, BlinkMacSystemFont, sans-serif';
var FLAT_FONT_MONO = exports.FLAT_FONT_MONO = '"IBM Plex Mono", ui-monospace, Menlo, Consolas, "DejaVu Sans Mono", monospace';
var FlatRow = exports.FlatRow = _styledComponents["default"].div.withConfig({
  displayName: "TileContext__FlatRow",
  componentId: "sc-1tycx6w-0"
})(["display:flex;align-items:center;gap:7px;min-width:0;box-sizing:border-box;"]);
var FlatDot = exports.FlatDot = _styledComponents["default"].span.withConfig({
  displayName: "TileContext__FlatDot",
  componentId: "sc-1tycx6w-1"
})(["flex:none;width:8px;height:8px;border-radius:50%;"]);
var FlatText = exports.FlatText = _styledComponents["default"].span.withConfig({
  displayName: "TileContext__FlatText",
  componentId: "sc-1tycx6w-2"
})(["flex:1 1 auto;min-width:0;font-size:12.5px;font-weight:600;line-height:1.2;color:#1b2227;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);